import axiosClient from './axios.client.js';

const PROPERTY_API = {
  // Get all properties
  getProperties: async () => {
    try {
      const response = await axiosClient.get('/properties');
      console.log('Property API response:', response); // Debug log
      return response; // axiosClient already returns res.data
    } catch (error) {
      console.error('Error fetching properties:', error);
      throw error;
    }
  },

  // Get a single property by ID
  getProperty: async (id) => {
    try {
      const response = await axiosClient.get(`/properties/${id}`);
      return response; // axiosClient already returns res.data
    } catch (error) {
      console.error('Error fetching property:', error);
      throw error;
    }
  },

  // Create a new property
  createProperty: async (propertyData) => {
    try {
      const response = await axiosClient.post('/properties', propertyData);
      return response; // axiosClient already returns res.data
    } catch (error) {
      console.error('Error creating property:', error);
      throw error;
    }
  },

  // Update an existing property
  updateProperty: async (id, propertyData) => {
    try {
      const response = await axiosClient.put(`/properties/${id}`, propertyData);
      return response; // axiosClient already returns res.data
    } catch (error) {
      console.error('Error updating property:', error);
      throw error;
    }
  },

  // Delete a property
  deleteProperty: async (id) => {
    try {
      const response = await axiosClient.delete(`/properties/${id}`);
      return response; // axiosClient already returns res.data
    } catch (error) {
      console.error('Error deleting property:', error);
      throw error;
    }
  },

  // Import properties
  importProperties: async (propertiesData) => {
    try {
      const response = await axiosClient.post('/properties/import', propertiesData);
      return response; // axiosClient already returns res.data
    } catch (error) {
      console.error('Error importing properties:', error);
      throw error;
    }
  },

  // Search properties
  searchProperties: async (searchParams) => {
    try {
      const response = await axiosClient.get('/properties/search', { params: searchParams });
      return response; // axiosClient already returns res.data
    } catch (error) {
      console.error('Error searching properties:', error);
      throw error;
    }
  },

  // Get property analytics
  getPropertyAnalytics: async (propertyId) => {
    try {
      const response = await axiosClient.get(`/properties/${propertyId}/analytics`);
      return response; // axiosClient already returns res.data
    } catch (error) {
      console.error('Error fetching property analytics:', error);
      throw error;
    }
  },

  // Get market analysis for a property
  getMarketAnalysis: async (propertyId) => {
    try {
      const response = await axiosClient.get(`/properties/${propertyId}/market-analysis`);
      return response; // axiosClient already returns res.data
    } catch (error) {
      console.error('Error fetching market analysis:', error);
      throw error;
    }
  },
};

export default PROPERTY_API;
